import { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { message } from 'antd'

import { useParams } from 'react-router-dom'

// components

import MentionEditor, {
    commentHtmlHasMedia,
} from '../../../components/MentionEditor/MentionEditor'

// slices

import { loginState } from '../../login/login.slice'

import {
    mainTaskById,
    taskById,
    updateComment,
    updateMainTaskComment,
} from '../../taskRefactored/tasks.slice'
import { isTaskMutationSuccess } from '../../taskRefactored/tasks.service'

const commentHasSubmittableBody = (mentionData, files) => {
    if (Array.isArray(files) && files.length > 0) return true
    if (String(mentionData?.comment || '').trim()) return true
    return commentHtmlHasMedia(mentionData?.value)
}

const ProjectCommentInput = ({
    taskId,
    taskListKind = 'support',
    projectId,
    onCommentAdded,

    setCommentChange,

    mentionData,

    setMentionData,

    files,

    setFiles,
}) => {
    const dispatch = useDispatch()

    const { userProfile } = useSelector(loginState)

    const { id: routeProjectId } = useParams()

    const resolvedProjectId = projectId || routeProjectId

    // Comment/Mention state

    const [clearEditor, setClearEditor] = useState(false)

    const [addCommentLoader, setAddCommentLoader] = useState(false)

    // Handle mention changes

    const handleChangeMentions = (newValue, newPlainTextValue, mentions) => {
        setMentionData({
            ...mentionData,
            value: newValue,
            comment: newPlainTextValue,
            mentionDataList: mentions,
        })
    }

    // Add comment function

    async function addComment(files) {
        setAddCommentLoader(true)

        const isMainTask = taskListKind === 'main'
        const commentPayload = {
            id: taskId,
            data: {
                fieldName: 'add',
                comment: {
                    userId: userProfile?._id,
                    username: userProfile?.userName,
                    createdDate: new Date().getTime(),
                    content: mentionData?.value || '',
                    mentionId: mentionData?.mentionDataList || [],
                    attachments: files?.length > 0 ? files : [],
                },
            },
        }

        const result = await dispatch(
            isMainTask
                ? updateMainTaskComment(commentPayload)
                : updateComment(commentPayload)
        )

        const data = result?.payload?.data

        if (data) {
            setMentionData({ ...mentionData, value: '', comment: '' })

            setFiles([])

            const { success, message: checkMessage } = data
            const isSuccess = isMainTask
                ? isTaskMutationSuccess(data)
                : Boolean(success)

            if (isSuccess) {
                setAddCommentLoader(false)

                const newComment = {
                    uId: userProfile?._id,
                    userId: userProfile?._id,
                    mentionId: mentionData?.mentionDataList,
                    attachments: files?.length > 0 ? files : [],
                    content: mentionData?.value,
                    createdDate: new Date().getTime(),
                    user: {
                        _id: userProfile?._id,
                        name: userProfile?.userName,
                        profilePicture: userProfile?.profilePicture,
                    },
                    username: userProfile?.userName,
                }

                if (setCommentChange) {
                    setCommentChange((prev) => [
                        newComment,

                        ...(Array.isArray(prev) ? prev : []),
                    ])
                }

                await dispatch(
                    isMainTask
                        ? mainTaskById({ _id: taskId })
                        : taskById({ _id: taskId })
                )

                if (onCommentAdded) {
                    onCommentAdded()
                }
            } else {
                if (checkMessage) {
                    message.error(checkMessage)

                    setAddCommentLoader(false)
                } else {
                    message.error('Something went wrong, try again later.')

                    setAddCommentLoader(false)
                }
            }
        }
    }

    // Submit comment with attachments (files are already uploaded URLs)

    async function s3Upload() {
        setAddCommentLoader(true)

        // Files are already uploaded URLs from MentionEditor

        const attachmentUrls = Array.isArray(files) ? files : []

        await addComment(attachmentUrls)

        setClearEditor(true)
    }

    useEffect(() => {
        if (clearEditor) {
            setClearEditor(false)
        }
    }, [clearEditor])

    return (
        <MentionEditor
            projectId={resolvedProjectId}
            mentionUserType={taskListKind === 'main' ? 'pms' : undefined}
            excludeUserIds={mentionData?.mentionDataList || []}
            handleChangeMentions={handleChangeMentions}
            value={mentionData?.value}
            clearTrigger={clearEditor}
            loadingButton={addCommentLoader}
            onClickComment={() => s3Upload()}
            disabledButton={!commentHasSubmittableBody(mentionData, files)}
            showInsertMenu
            allowInlineMedia
            getFileList={(files) => {
                setFiles(files)
            }}
        />
    )
}

export default ProjectCommentInput
